import { render, staticRenderFns } from "./SaleOrderDialog.vue?vue&type=template&id=67815d2e&scoped=true&"
import script from "./SaleOrderDialog.vue?vue&type=script&lang=js&"
export * from "./SaleOrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67815d2e",
  null
  
)

export default component.exports